import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail, Phone, MapPin } from "lucide-react";
import { LOGO_URL } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="bg-foreground text-background mt-32">
      <div className="max-w-7xl mx-auto px-6 py-20 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <img src={LOGO_URL} alt="La dimora di Patty" loading="lazy" decoding="async" className="w-40 h-40 object-contain -ml-3 mb-2" />
          <p className="text-background/65 leading-relaxed max-w-md">
            {t("footer.desc")}
          </p>
          <div className="flex gap-4 mt-8">
            <a href="#" aria-label="Instagram" className="w-10 h-10 rounded-full border border-background/30 flex items-center justify-center hover:border-accent hover:text-accent transition-colors">
              <Instagram size={16} />
            </a>
            <a href="#" aria-label="Facebook" className="w-10 h-10 rounded-full border border-background/30 flex items-center justify-center hover:border-accent hover:text-accent transition-colors">
              <Facebook size={16} />
            </a>
          </div>
        </div>

        <div>
          <div className="overline text-accent mb-5">{t("footer.explore")}</div>
          <ul className="space-y-3 text-background/75">
            <li><Link to="/" className="hover:text-accent transition-colors">{t("nav.home")}</Link></li>
            <li><Link to="/gallery" className="hover:text-accent transition-colors">{t("nav.gallery")}</Link></li>
            <li><Link to="/rooms" className="hover:text-accent transition-colors">{t("nav.rooms")}</Link></li>
            <li><Link to="/experience" className="hover:text-accent transition-colors">{t("nav.experience")}</Link></li>
            <li><Link to="/booking" className="hover:text-accent transition-colors">{t("nav.booking")}</Link></li>
            <li><Link to="/contact" className="hover:text-accent transition-colors">{t("nav.contact")}</Link></li>
          </ul>
        </div>

        <div>
          <div className="overline text-accent mb-5">{t("footer.contact")}</div>
          <ul className="space-y-3 text-background/75 text-sm">
            <li className="flex items-start gap-3"><MapPin size={14} className="mt-1 text-accent" /> Via Numicia 40 — 67031 Castel di Sangro (AQ), Abruzzo</li>
            <li className="flex items-start gap-3"><Phone size={14} className="mt-1 text-accent" /> +39 379 29 23 929</li>
            <li className="flex items-start gap-3"><Mail size={14} className="mt-1 text-accent" /> ospiti@ladimoradipatty.it</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background/10">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-background/55">
          <div>© {new Date().getFullYear()} La dimora di Patty. {t("footer.rights")}</div>
          <div className="flex gap-6">
            <a href="#" className="hover:text-accent">Privacy</a>
            <a href="#" className="hover:text-accent">GDPR</a>
            <a href="#" className="hover:text-accent">Termini</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
